import { useState, useEffect } from "react";
import { companyInfo } from "@/mocks/home";
import logo from "@/assets/logo.png";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navItems = [
    { label: "ホーム", href: "#hero" },
    { label: "サービス", href: "#services" },
    { label: "選ばれる理由", href: "#reasons" },
    { label: "会社概要", href: "#company" },
    { label: "お問い合わせ", href: "#contact" },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled
          ? "bg-background-100/95 backdrop-blur-md border-b border-accent-300/20"
          : "bg-transparent"
        }`}
    >
      <div className="site-container">
        <div className="flex items-center justify-between h-16 md:h-20">
          <a href="#hero" className="flex items-center gap-3 group">
            <img src={logo} alt="" className="h-10 md:h-12 w-auto object-contain" />
            <div className="flex flex-col">

              <span className="text-foreground-50 font-bold font-heading text-xs md:text-base leading-tight">
                {companyInfo.name}
              </span>
              <span className="text-foreground-700 text-[10px] md:text-xs leading-tight tracking-wider">
                {companyInfo.englishName}
              </span>
            </div>
          </a>

          <div className="hidden lg:flex items-center gap-8 lg:gap-10">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="text-foreground-300 hover:text-primary-400 text-sm font-medium transition-colors duration-200 whitespace-nowrap"
              >
                {item.label}
              </a>
            ))}
          </div>

          <div className="hidden  lg:flex items-center gap-4">
            <a
              href={`tel:${companyInfo.phone}`}
              className="flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-5 py-2.5 rounded-md text-sm font-semibold transition-colors duration-200 whitespace-nowrap"
            >
              <i className="ri-phone-line"></i>
              {companyInfo.phone}
            </a>
          </div>

          <button
            className="lg:hidden w-10 h-10 flex items-center justify-center text-foreground-50"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="メニューを開く"
          >
            <i className={`ri-${mobileOpen ? "close" : "menu"}-line text-2xl`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="lg:hidden bg-background-100/98 backdrop-blur-md border-t border-background-300/30">
          <div className="px-4 py-4 space-y-3">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="block text-foreground-300 hover:text-primary-400 text-sm font-medium py-2 transition-colors"
                onClick={() => setMobileOpen(false)}
              >
                {item.label}
              </a>
            ))}
            <a
              href={`tel:${companyInfo.phone}`}
              className="flex items-center gap-2 bg-primary-500 text-background-50 px-4 py-3 rounded-md text-sm font-semibold mt-3"
            >
              <i className="ri-phone-line"></i>
              {companyInfo.phone}
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}